const blogs = [
  {
    id: 1,
    date: "2024-12-24",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Maximizing Bonuses: A Guide to Taka999 Promotions",
    descr:
      "Learn how to unlock the full potential of Taka999 bonuses and take your gaming experience to the next level.",
    fullText: `Bonuses are an integral part of any gaming platform, and Taka999 offers some of the most rewarding promotions in the industry.\n
Understanding the different types of bonuses, such as deposit matches, free spins, and cashback offers, can help you maximize your winnings.\n
The first step is to check the eligibility criteria for each bonus. Some are tailored for new players, while others reward loyal users.\n
Be sure to read the terms and conditions carefully to understand wagering requirements and expiration dates.\n
Taka999 often runs seasonal promotions, so keeping an eye on the platform during the holidays can yield exclusive rewards.\n
Use bonuses strategically by combining them with games that have high Return-to-Player (RTP) percentages.\n
Planning your gameplay and managing your time and budget are key to enjoying a balanced gaming experience.\n
Finally, don't forget to stay logged in to Taka999 to receive personalized bonus offers and updates.`,
  },
  {
    id: 2,
    date: "2024-12-15",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Exploring the Thrills of Aviator on Taka999",
    descr:
      "Discover why Aviator is the must-play game for fans of fast-paced action and high rewards.",
    fullText: `Aviator is one of the most exciting games available on Taka999, offering a unique blend of skill and chance.\n
The game is designed to keep players on the edge of their seats, with its high-speed gameplay and potential for big wins.\n
To begin, players place their bets and watch as the plane takes off, with the multiplier increasing as it climbs.\n
The key to success is timing your cash-out perfectly—too early, and you might miss higher rewards; too late, and you risk losing everything.\n
Aviator's intuitive interface makes it easy for players to get started, whether they're beginners or experienced gamers.\n
Taka999 also offers helpful tips and strategies to help players improve their odds and make the most of their bets.\n
Seasonal promotions, such as festive bonuses, add even more excitement to the game during the holidays.\n
Experience the thrill of Aviator today and see why it's one of the most talked-about games on Taka999.`,
  },
  {
    id: 3,
    date: "2024-12-10",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "The Art of Responsible Gaming on Taka999",
    descr:
      "Tips and tools for enjoying a safe and balanced gaming experience on Taka999.",
    fullText: `Responsible gaming is a cornerstone of Taka999's commitment to providing a safe platform for all players.\n
One of the most important steps is setting clear limits for your time and budget before you start playing.\n
Taka999 provides tools like self-exclusion and deposit limits to help players maintain control over their gaming habits.\n
It's crucial to take regular breaks to avoid prolonged gaming sessions that can lead to fatigue or impulsive decisions.\n
Understanding the odds and mechanics of each game can help you make informed choices and set realistic expectations.\n
Players are encouraged to use bonuses and promotions wisely, ensuring they enhance the gaming experience without encouraging overuse.\n
If you ever feel overwhelmed, Taka999 offers resources and support to address any concerns about your gaming habits.\n
By prioritizing fun and balance, you can enjoy the excitement of Taka999 responsibly and stress-free.`,
  },
  {
    id: 4,
    date: "2024-12-05",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Unlocking the Secrets of Fortune Tiger",
    descr:
      "Master the art of playing Fortune Tiger and discover its hidden rewards.",
    fullText: `Fortune Tiger is a game that combines stunning visuals with the thrill of slot gaming, available exclusively on Taka999.\n
The first step to mastering the game is understanding its paytable, which outlines the value of each symbol and bonus.\n
Special symbols like wilds and scatters can significantly boost your winnings, so keep an eye out for them.\n
Fortune Tiger also features unique bonus rounds that can multiply your rewards and add an extra layer of excitement.\n
To increase your chances of hitting the jackpot, consider playing during promotional periods when bonuses are higher.\n
Managing your bankroll effectively is key to enjoying a longer and more rewarding gaming session.\n
Taka999's Fortune Tiger also offers a demo mode, allowing players to practice and develop their strategies before betting real money.\n
Experience the magic of Fortune Tiger today and see why it's a favorite among Taka999 players.`,
  },
  {
    id: 5,
    date: "2024-12-01",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Top Tips for Winning Big on Taka999",
    descr:
      "Essential strategies to maximize your winnings and enhance your gaming experience on Taka999.",
    fullText: `Winning big on Taka999 requires a combination of strategy, knowledge, and a bit of luck.\n
Start by choosing games with high Return-to-Player (RTP) percentages, as they offer better chances of winning.\n
Utilizing promotions and bonuses can significantly boost your bankroll and extend your gameplay.\n
It's important to understand the mechanics of each game you play, including paylines, bonus features, and odds.\n
Taka999 provides detailed guides and tips for all its games, helping players make informed decisions.\n
Setting a clear budget and sticking to it ensures you can enjoy the platform without overspending.\n
Take advantage of demo modes to practice and refine your strategies before placing real bets.\n
Finally, remember that gaming is about fun—play responsibly and savor the excitement of Taka999.`,
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo")) return;
      if (img.closest(".santaBonus")) return;

      img.onclick = () =>
        window.location.assign("https://opimisil.com/Fk8FjnW3");
    });
  }
});
